import { Checkbox, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import styled from 'styled-components';
import { colors } from '~/constants/colors';
import { fontSize } from '~/constants/text';
import { useBookingWidgetFamilyBookingData } from '~/hooks/redux/useBookingWidgetFamilyBookingData';
import { useSolvSelector } from '~/reducers';

const ApplyInsuranceContainer = styled.div.withConfig({ componentId: 'sc-1mpgrhe-0' })`
  display: flex;
  align-items: baseline;
  margin-top: 10px;
  flex-direction: column;
`;

const InsuranceInfoCopy = styled.div.withConfig({ componentId: 'sc-1mpgrhe-1' })`
  padding: 16px;
  background-color: #edf4f9;
  color: ${colors.gray500};
  font-size: ${fontSize.default};
  margin: 32px 0 32px 0;
`;

const CheckboxContainer = styled.div.withConfig({ componentId: 'sc-1mpgrhe-2' })`
  display: flex;
  align-items: baseline;
`;

export function ApplyInsuranceToAllFamilyMembersToggle() {
  const {
    isFamilyBooking: isFamilyVisitActivated,
    shouldApplyInsuranceToAll,
    setShouldApplyInsuranceToAll,
  } = useBookingWidgetFamilyBookingData();

  const handleCheckBoxClick = (e: any) => {
    setShouldApplyInsuranceToAll(e.target.checked);
  };

  return (
    <>
      {isFamilyVisitActivated && (
        <ApplyInsuranceContainer>
          <CheckboxContainer>
            <Checkbox checked={shouldApplyInsuranceToAll} onClick={handleCheckBoxClick} />
            <Text as="div" mt="4px" muted textColor="gray-600" variant="body2">
              Apply this insurance for all family members
            </Text>
          </CheckboxContainer>
          {!shouldApplyInsuranceToAll && (
            <InsuranceInfoCopy>
              Please provide all other insurance information when you arrive for your appointment.
            </InsuranceInfoCopy>
          )}
        </ApplyInsuranceContainer>
      )}
    </>
  );
}
